class InpectionPointEdit {
  constructor(data = {}) {
    this.idPuntoInspeccion = data.idPuntoInspeccion || 0;
    this.descripcion = data.descripcion || "";
    this.descripcionIngles = data.descripcionIngles || "";
    this.estatus = data.estatus || true;
  }
}

class InpectionPointAdd {
  constructor(data = {}) {
    this.idPuntoInspeccion = data.idPuntoInspeccion || 0;
    this.descripcion = data.descripcion || "";
    this.descripcionIngles = data.descripcionIngles || "";
    this.estatus = data.estatus || true;
  }
}

export { InpectionPointEdit, InpectionPointAdd };
